import Jsona from "jsona";

import { setUser, captureException } from "@sentry/browser";
import HTTP from "../http";
import store from "../../store";

const dataFormatter = new Jsona();

const create = async payload => {
  try {
    let offer = await HTTP.normal.post("/order-offers", payload);

    return offer;
  } catch (e) {
    setUser({ id: payload.data.relationships.customer.data.id });
    captureException(e);
    throw "Ocorreu um erro ao criar a oferta de limpeza!";
  }
};

const checkOpenOffer = async addressId => {
  try {
    const response = await HTTP.normal.get(`/order-offers/open/${addressId}`);
    return response;
  } catch (e) {
    throw e;
  }
};

const showProfessionals = async () => {
  try {
    let response = await HTTP.normal.get(
      "/finders/order-offers/willing_professionals"
    );

    store.dispatch(
      "orderScheduler/setProfessionals",
      dataFormatter.deserialize(response.data)
    );
  } catch (e) {
    return;
  }
};

const createOrderFromOffer = async payload => {
  try {
    let order = await HTTP.normal.post("/order-offers/create-order", payload);
    return dataFormatter.deserialize(order.data);
  } catch (e) {
    setUser({ id: payload.data.relationships.customer.data.id });
    captureException(e);
    throw "Ocorreu um erro ao criar o pedido!";
  }
};

const cancelOrderOffer = async key => {
  try {
    await HTTP.normal.post("/order-offers/delete-offer", { key: key });
    return dataFormatter.deserialize(order.data);
  } catch (e) {
    return;
  }
};

export default {
  create,
  checkOpenOffer,
  showProfessionals,
  createOrderFromOffer,
  cancelOrderOffer
};



// WEBPACK FOOTER //
// ./src/api/modules/order_offer.js